/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PlayerOrderEnum {
    Plus = '+',
    Minus = '-',
    QuestionMark = '?'
}


export function PlayerOrderEnumFromJSON(json: any): PlayerOrderEnum {
    return PlayerOrderEnumFromJSONTyped(json, false);
}

export function PlayerOrderEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerOrderEnum {
    return json as PlayerOrderEnum;
}

export function PlayerOrderEnumToJSON(value?: PlayerOrderEnum | null): any {
    return value as any;
}

